import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'jhi-filter-block',
    templateUrl: './filter-block.component.html',
    styleUrls: ['./filter-block.component.scss']
})
export class FilterBlockComponent implements OnInit {
    @Output()
    statusChanges: EventEmitter<String> = new EventEmitter();

    @Input()
    statutFilter: string;

    constructor() {}

    ngOnInit() {}

    applyFilter(value: string) {
        this.statusChanges.emit(value);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/home/mes-dossiers/filter-block/filter-block.component.ts